import { getMyPyloAros } from "@/services/acl.service";
import { useQuery } from "@tanstack/react-query";
import { useMyUser } from "../auth/use-my-user";
import { useCurrentUserId } from "@/contexts/customer-id-context";

// Single source of truth for the current user's AROs.
// The user id comes straight from the JWT (SSR-seeded into context), so this
// query fires immediately on mount — in parallel with `me` — instead of waiting
// for the `me` round-trip. We fall back to the `me`-resolved id only if the
// context id is somehow missing (e.g. an edge-case first render without a token).
export const useMyAros = () => {
  const userIdFromToken = useCurrentUserId();
  const { myUser } = useMyUser();
  const userId = userIdFromToken ?? myUser?.current_user?.data?.id ?? null;

  const query = useQuery({
    queryKey: ["myAros", userId],
    queryFn: () => getMyPyloAros({ userId: userId ?? "" }),
    enabled: !!userId,
  });

  return query;
};
